export const RippleMark = ({ size = 36, className = "" }) => (
  <svg viewBox="0 0 48 48" width={size} height={size} className={`rp-mark ${className}`} role="img" aria-label="RippleImpact logo">
    <path className="rp-pin" d="M24 3C14.3 3 6.5 10.7 6.5 20.3 6.5 32.4 24 45 24 45s17.5-12.6 17.5-24.7C41.5 10.7 33.7 3 24 3z" />
    <circle className="rp-ring rp-ring-outer" cx="24" cy="20" r="11" fill="none" strokeWidth="2.4" />
    <circle className="rp-ring" cx="24" cy="20" r="6.8" fill="none" strokeWidth="2.6" />
    <circle className="rp-core" cx="24" cy="20" r="3" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`whitespace-nowrap tracking-[0.01em] text-[#1E3A8A] ${className}`} data-testid="brand-wordmark">
    <span className="font-semibold">Ripple</span><span className="font-bold text-[#2E7D32]">Impact</span>
  </span>
);

export const Logo = ({ size = 36, textClass = "text-xl" }) => (
  <span className="flex items-center gap-2.5"><RippleMark size={size} /><Wordmark className={textClass} /></span>
);
